import { Component, OnChanges, SimpleChanges, Input, Output, ViewChild, ViewEncapsulation, ViewContainerRef, EventEmitter } from '@angular/core';
import {Store} from '@ngrx/store';
import { PageNotificationService } from '@signature-it/ngx-generic/services';
import { CartService } from '@signature-it/ngx-catalogue/services';
import { OrdersFullLayoutComponentGeneric} from './tmpl/full/full';
import { OrdersCheckoutLayoutComponentGeneric} from './tmpl/checkout/checkout';
import { CartActions } from '@signature-it/ngx-catalogue/store/actions';
import {Observable, Subscription} from "rxjs";
import {getAddToCartError, getAddToCartOpenModal, getUpdatedCartSuccess} from '@signature-it/ngx-catalogue/store/selectors';
import {MatDialog, MatDialogRef} from "@angular/material/dialog";
import { AddToSuccessModalComponentGeneric } from '@signature-it/ngx-catalogue/components/success-modal';

declare let _: any;

@Component({
    selector: 'cart-orders',
    templateUrl: './orders.html',
    styleUrls: ['./orders.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class CartOrdersComponentGeneric implements OnChanges {
    @ViewChild('layoutFull') layoutFull: OrdersFullLayoutComponentGeneric;
    @ViewChild('layoutCheckout') layoutCheckout: OrdersCheckoutLayoutComponentGeneric;
    @Input('mode') mode: string = 'full'; // full, checkout
    @Input('items') items = {
        TransactionItems: Array<object>(),
        OrderItems: Array<object>()
    };


    @Input('isProductsAmountWithinRange') isProductsAmountWithinRange = true;
    openModalSub: Subscription;
    addToCartError$: Observable<string>;
    dialogRef : MatDialogRef<AddToSuccessModalComponentGeneric>;
    updatedCartSuccess$: Observable<boolean>;
    
	constructor(protected notifySvc: PageNotificationService,
                protected cartSvc: CartService,
                protected store$: Store<any>,
                public dialog: MatDialog) {
         this.addToCartError$ = this.store$.select(getAddToCartError);
         this.updatedCartSuccess$ = this.store$.select(getUpdatedCartSuccess);
    }


    ngOnChanges(changes: SimpleChanges): void {
	    if(changes['items'] && !_.isEmpty(this.items)) {
            const value = changes['items'].currentValue;
            this.items.TransactionItems = value.TransactionItems;
            this.items.OrderItems = value.OrderItems;
        }
    }

    get TransactionItems() {
        return this.items.TransactionItems;
    }

    get OrdersItems() {
        return this.items.OrderItems;
    }

    onRemoveAll() {
        const action = CartActions.removeAllItems();
        this.store$.dispatch(action);
    }

    onUpdateAll(data) {
	    this.store$.dispatch(CartActions.updateAllQuantities());
        const action = CartActions.addToCart(data);
        this.openModalSub = this.addToCartError$.subscribe(error => {
            if (error) {
                const initialState = {
                    title: error['error'] ? error['error']:error,
                        //redirectText: 'Empty and Continue',
                        continueText: 'Cancel'
                    };
                    this.dialogRef = this.dialog.open(
                         AddToSuccessModalComponentGeneric,
                         {data: initialState, maxWidth: 'none', maxHeight: 'none', panelClass: 'add-product-dialog'}
                    );
                    /*this.dialogRef.afterClosed().subscribe(dialogResult => {
                        if ( dialogResult ) {
                          this.removeAllItems(data); //todo
                    }
                });*/
                this.closeModal();
                //this.store$.dispatch(CartActions.getCart());
            } else {
                if (this.openModalSub) this.openModalSub.unsubscribe();
            }
        });    
        this.store$.dispatch(action);
    }    
     
    closeModal() {
        const action = CartActions.addToCartCloseFailure();        
        this.store$.dispatch(action);
    }

    onRemoveItem(item: object) {
        const action = CartActions.removeItem(item);
        this.store$.dispatch(action);
    }
    removeAllItems(data) {
        const actionRemoveAllItems = CartActions.removeAllItems();
        this.store$.dispatch(actionRemoveAllItems);
        this.updatedCartSuccess$.subscribe(isUpdate => {
            if (isUpdate) {
               const action = CartActions.addToCart([data], {afterRemoveAll: true});
               this.store$.dispatch(action);
            }
        });
    }


}
